export default "__VITE_ASSET__BMp7R$QV__"